/*
  hm-illustrations.js — Hairmosa, illustrations validées de la fiche tissage.
  API (window.HMIllustrations) :
    new Silhouette(svgElement, { longueur: 20, texture: 'lisse' })  -> .allerA(longueurEnPouces)
      texture : 'lisse' (par défaut), 'boucle' ou 'crepu'. Si l'option est absente, lit l'attribut data-texture du svg.
      svgElement = le <svg class="hm-silhouette"> du snippet hm-silhouette.liquid
    new SchemaClosure(svgElement, { format: '4x4' }) -> .afficher('2x6' | '4x4' | '5x5' | 'LxP')
      svgElement = le <svg class="hm-schema-closure"> du snippet hm-lace-schema.liquid
  Animations en JavaScript (compatibles Safari), désactivées si prefers-reduced-motion.
  Ne pas modifier les valeurs de dessin : elles sont calées sur les illustrations.
*/
(function () {
  'use strict';
  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function animer(duree, surImage) {
    if (reduit) { surImage(1); return function () {}; }
    var t0 = performance.now(), id;
    function pas(t) {
      var k = Math.min(1, (t - t0) / duree), e = 1 - Math.pow(1 - k, 3);
      surImage(e);
      if (k < 1) id = requestAnimationFrame(pas);
    }
    id = requestAnimationFrame(pas);
    return function () { cancelAnimationFrame(id); };
  }

  /* ---------- Silhouette de longueur ---------- */
  // Hauteur des pointes (repère 0-160) calée sur le corps de l'illustration
  var HAUTEURS = {
    lisse:  { 10: 46, 12: 51, 14: 57, 16: 66, 18: 75, 20: 85, 22: 91, 24: 97, 26: 104, 28: 112, 30: 124, 32: 134 },
    // Bouclé : écart régulier de 6,2 par tranche de 2 pouces (18" comme un 16" lisse, 28" à la taille)
    // Crépu lissé : mêmes hauteurs que le lisse
    crepu:  { 10: 46, 12: 51, 14: 57, 16: 66, 18: 75, 20: 85, 22: 91, 24: 97, 26: 104, 28: 112, 30: 124, 32: 134 },
    boucle: { 10: 41.2, 12: 47.4, 14: 53.6, 16: 59.8, 18: 66, 20: 72.2, 22: 78.4, 24: 84.6, 26: 90.8, 28: 97, 30: 103.2, 32: 109.4 }
  };
  function yPourLongueur(l, texture) {
    var table = HAUTEURS[texture] || HAUTEURS.lisse;
    if (table[l] != null) return table[l];
    var cles = Object.keys(table).map(Number).sort(function (a, b) { return a - b; });
    if (l <= cles[0]) return table[cles[0]];
    if (l >= cles[cles.length - 1]) return table[cles[cles.length - 1]];
    for (var i = 0; i < cles.length - 1; i++) {
      if (l > cles[i] && l < cles[i + 1]) return table[cles[i]] + (table[cles[i + 1]] - table[cles[i]]) * (l - cles[i]) / (cles[i + 1] - cles[i]);
    }
    return table[20];
  }
  function cheveux(Y) {
    var s = Y - 6, a = 48.5 + (s - 48.5) * .35, b = 48.5 + (s - 48.5) * .7;
    return 'M60 3 C49.8 3 45.3 10.4 45.3 19.5 C45.3 29 44.7 39 43.1 48.5 C42.5 ' + a + ' 42.5 ' + b + ' 43.3 ' + s +
      ' Q44.5 ' + (Y - 1.2) + ' 51.5 ' + (Y + .6) + ' Q56 ' + (Y + 1.6) + ' 60 ' + (Y + 2.6) + ' Q64 ' + (Y + 1.6) + ' 68.5 ' + (Y + .6) +
      ' Q75.5 ' + (Y - 1.2) + ' 76.7 ' + s + ' C77.5 ' + b + ' 77.5 ' + a + ' 76.9 48.5 C75.3 39 74.7 29 74.7 19.5 C74.7 10.4 70.2 3 60 3 Z';
  }
  function reflets(Y) {
    return ['M52.4 8.6 C49.4 20 48.6 34 49 ' + (Y - 5), 'M57.4 5.4 C56.7 20 56.3 38 56.6 ' + (Y - 1),
      'M63.4 6.2 C64.4 20 64.9 38 64.6 ' + (Y - 1.8), 'M67.8 9.4 C70.8 21 71.4 36 71 ' + (Y - 5.5)];
  }
  // ----- Cheveux bouclés -----
  function demiLargeurBoucle(y, Y) {
    var pts = [[14, 16.2], [28, 19.8], [46, 23.6], [62, 25.6], [200, 26.2]];
    var w = pts[pts.length - 1][1];
    for (var i = 0; i < pts.length - 1; i++) {
      if (y <= pts[i + 1][0]) { var t = (y - pts[i][0]) / (pts[i + 1][0] - pts[i][0]); w = pts[i][1] + (pts[i + 1][1] - pts[i][1]) * Math.max(0, t); break; }
    }
    var debut = Y - 12; if (y > debut) w *= 1 - .12 * ((y - debut) / 12);
    return w;
  }
  // Amplitudes fixes par index : le contour ne « saute » pas pendant l'animation
  var AMP = [2.4, 1.7, 2.8, 2.1, 2.6, 1.8, 2.9, 2.2, 2.5, 1.9];
  function cheveuxBoucles(Y) {
    function f(n) { return n.toFixed(2); }
    var y0 = 15, yb = Y - 3.5, N = 9, i, k;
    var ys = []; for (i = 0; i <= N; i++) ys.push(y0 + (yb - y0) * i / N);
    function cote(sens) {
      var idx = []; for (i = 0; i <= N; i++) idx.push(i);
      if (sens > 0) idx.reverse();
      var d = '';
      for (k = 1; k < idx.length; k++) {
        var ia = idx[k - 1], iz = idx[k], yz = ys[iz], ym = (ys[ia] + yz) / 2, a = AMP[Math.min(ia, iz)];
        var xz = 60 + sens * (demiLargeurBoucle(yz, Y) - .6), xm = 60 + sens * (demiLargeurBoucle(ym, Y) + a);
        d += ' Q' + f(xm) + ' ' + f(ym) + ' ' + f(xz) + ' ' + f(yz);
      }
      return d;
    }
    var wl = demiLargeurBoucle(yb, Y), xg = 60 - wl + .6, xd = 60 + wl - .6, M = 7, bas = '';
    for (i = 1; i <= M; i++) {
      var xa = xg + (xd - xg) * (i - 1) / M, xz2 = xg + (xd - xg) * i / M, xm2 = (xa + xz2) / 2;
      var pointe = 2.4 + Math.sin(Math.PI * (i - .5) / M) * 2.2 + AMP[i] * .35;
      bas += ' Q' + f(xm2) + ' ' + f(Y + pointe) + ' ' + f(xz2) + ' ' + f(i === M ? yb : Y + .6);
    }
    var hw = demiLargeurBoucle(y0, Y);
    var haut = ' C' + f(60 + hw + 1.2) + ' 9 ' + f(60 + hw - 2) + ' 3.2 66.4 2.8 Q63.4 .4 60 1.8 Q56.6 .4 53.6 2.8 C' + f(60 - hw + 2) + ' 3.2 ' + f(60 - hw - 1.2) + ' 9 ' + f(60 - hw + .6) + ' ' + y0;
    return 'M' + f(60 - hw + .6) + ' ' + y0 + cote(-1) + bas + cote(1) + haut + ' Z';
  }
  function textureBoucles(Y) {
    // Colonnes d'anglaises : ondulations serrées qui suivent la largeur des cheveux
    var colonnes = [-.78, -.47, -.16, .16, .47, .78], pas = 4.4, amp = 1.9;
    return colonnes.map(function (u, c) {
      var debut = 7 + (c % 2) * 2.2, fin = Y - 2.5 - (c % 3) * 1.2;
      var y = debut, x = 60 + u * (demiLargeurBoucle(y, Y) - 4.5), chemin = 'M' + x.toFixed(2) + ' ' + y.toFixed(2), signe = c % 2 ? 1 : -1;
      while (y + pas <= fin) {
        var y2 = y + pas, x2 = 60 + u * (demiLargeurBoucle(y2, Y) - 4.5), xm = (x + x2) / 2 + signe * amp;
        chemin += ' Q' + xm.toFixed(2) + ' ' + (y + pas / 2).toFixed(2) + ' ' + x2.toFixed(2) + ' ' + y2.toFixed(2);
        y = y2; x = x2; signe = -signe;
      }
      return chemin;
    });
  }

  // ----- Cheveux crépus lissés -----
  function demiLargeurCrepu(y, Y) {
    var pts = [[12, 15.9], [28, 18.9], [46, 21.6], [62, 22.8], [200, 23.2]];
    var w = pts[pts.length - 1][1];
    for (var i = 0; i < pts.length - 1; i++) {
      if (y <= pts[i + 1][0]) { var t = (y - pts[i][0]) / (pts[i + 1][0] - pts[i][0]); w = pts[i][1] + (pts[i + 1][1] - pts[i][1]) * Math.max(0, t); break; }
    }
    var debut = Y - 10; if (y > debut) w *= 1 - .05 * ((y - debut) / 10);
    return w;
  }
  // Petites irrégularités fixes : un contour légèrement texturé, sans effet de boucle
  var FRISE = [.18, .1, .22, .12, .16, .24, .08, .18, .14, .22, .12, .2, .16, .1, .24, .14, .18, .12, .2, .16, .12, .22, .1, .18, .14, .2, .12, .16];
  function cheveuxCrepus(Y) {
    function f(n) { return n.toFixed(2); }
    var y0 = 12, yb = Y - 2, N = 26, i, k;
    var ys = []; for (i = 0; i <= N; i++) ys.push(y0 + (yb - y0) * i / N);
    function cote(sens) {
      var idx = []; for (i = 0; i <= N; i++) idx.push(i);
      if (sens > 0) idx.reverse();
      var d = '';
      for (k = 1; k < idx.length; k++) {
        var ia = idx[k - 1], iz = idx[k], yz = ys[iz], ym = (ys[ia] + yz) / 2, a = FRISE[Math.min(ia, iz)];
        d += ' Q' + f(60 + sens * (demiLargeurCrepu(ym, Y) + a)) + ' ' + f(ym) + ' ' + f(60 + sens * (demiLargeurCrepu(yz, Y) - .3)) + ' ' + f(yz);
      }
      return d;
    }
    var wl = demiLargeurCrepu(yb, Y), xg = 60 - wl + .3, xd = 60 + wl - .3, M = 12, bas = '';
    for (i = 1; i <= M; i++) {
      var xa = xg + (xd - xg) * (i - 1) / M, xz = xg + (xd - xg) * i / M;
      bas += ' Q' + f((xa + xz) / 2) + ' ' + f(Y + .6 + FRISE[i] * 1.2 + Math.sin(Math.PI * (i - .5) / M) * .9) + ' ' + f(xz) + ' ' + f(i === M ? yb : Y + .2);
    }
    var hw = demiLargeurCrepu(y0, Y);
    var haut = ' C' + f(60 + hw + .8) + ' 5.4 67.5 1.4 60 1.4 C52.5 1.4 ' + f(60 - hw - .8) + ' 5.4 ' + f(60 - hw + .3) + ' ' + y0;
    return 'M' + f(60 - hw + .3) + ' ' + y0 + cote(-1) + bas + cote(1) + haut + ' Z';
  }
  function textureCrepue(Y) {
    // Fibres serrées légèrement ondulées : aspect mat et texturé d'un cheveu crépu lissé
    var colonnes = [-.8, -.54, -.27, 0, .27, .54, .8], pas = 3.2, amp = .14;
    return colonnes.map(function (u, c) {
      var debut = 5 + (c % 3) * 1.4, fin = Y - 2.5 - (c % 2) * 1.6, ampC = amp * (c % 3 === 1 ? 1.3 : 1);
      var y = debut, x = 60 + u * (demiLargeurCrepu(y, Y) - 3), chemin = 'M' + x.toFixed(2) + ' ' + y.toFixed(2), signe = c % 2 ? 1 : -1;
      while (y + pas <= fin) {
        var y2 = y + pas, x2 = 60 + u * (demiLargeurCrepu(y2, Y) - 3);
        chemin += ' Q' + ((x + x2) / 2 + signe * ampC).toFixed(2) + ' ' + (y + pas / 2).toFixed(2) + ' ' + x2.toFixed(2) + ' ' + y2.toFixed(2);
        y = y2; x = x2; signe = -signe;
      }
      return chemin;
    });
  }

  function Silhouette(svg, options) {
    options = options || {};
    this.svg = svg;
    this.texture = options.texture || svg.getAttribute('data-texture') || 'lisse';
    if (!HAUTEURS[this.texture]) this.texture = 'lisse';
    this.cheveux = svg.querySelector('.hm-silhouette__cheveux');
    this.groupe = svg.querySelector('.hm-silhouette__reflets');
    var nb = this.texture === 'boucle' ? 6 : (this.texture === 'crepu' ? 7 : 4);
    if (this.groupe && this.groupe.querySelectorAll('path').length !== nb) {
      this.groupe.innerHTML = new Array(nb + 1).join('<path/>');
    }
    if (this.groupe && this.texture === 'boucle') { this.groupe.setAttribute('stroke-width', '.65'); this.groupe.setAttribute('opacity', '.6'); }
    if (this.groupe && this.texture === 'crepu') { this.groupe.setAttribute('stroke-width', '.5'); this.groupe.setAttribute('opacity', '.42'); }
    this.reflets = this.groupe ? this.groupe.querySelectorAll('path') : [];
    this.y = yPourLongueur(options.longueur || 20, this.texture);
    this.stop = function () {};
    this.dessiner(this.y);
  }
  Silhouette.prototype.dessiner = function (Y) {
    var t = this.texture;
    this.cheveux.setAttribute('d', t === 'boucle' ? cheveuxBoucles(Y) : (t === 'crepu' ? cheveuxCrepus(Y) : cheveux(Y)));
    var r = t === 'boucle' ? textureBoucles(Y) : (t === 'crepu' ? textureCrepue(Y) : reflets(Y));
    for (var i = 0; i < this.reflets.length; i++) this.reflets[i].setAttribute('d', r[i] || '');
  };
  Silhouette.prototype.allerA = function (longueur) {
    var self = this, depart = this.y, cible = yPourLongueur(Number(longueur), this.texture);
    this.stop();
    this.stop = animer(420, function (e) { self.y = depart + (cible - depart) * e; self.dessiner(self.y); });
  };

  /* ---------- Schéma de closure ---------- */
  var UX = 14, UY = 10.5, BAS = 86, CX = 49.7, RETRAIT = .9;
  function lireFormat(f) {
    var m = String(f).match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    return m ? { l: parseFloat(m[1].replace(',', '.')), p: parseFloat(m[2].replace(',', '.')) } : { l: 4, p: 4 };
  }
  function raiesPour(l) { return l <= 2 ? [0] : (l <= 4 ? [0, -.3] : [0, -.32, .32]); }
  function forme(l, p) {
    var wb = l * UX, wt = wb * RETRAIT, h = p * UY, yt = BAS - h;
    var s1 = wb * .055, s2 = wt * .11, s3 = h * .045, r = Math.min(3.2, wb * .09);
    var BL = [CX - wb / 2, BAS], BR = [CX + wb / 2, BAS], TR = [CX + wt / 2, yt], TL = [CX - wt / 2, yt];
    function vers(a, b, d) { var dx = b[0] - a[0], dy = b[1] - a[1], L = Math.hypot(dx, dy); return [a[0] + dx / L * d, a[1] + dy / L * d]; }
    function f(q) { return q[0].toFixed(2) + ' ' + q[1].toFixed(2); }
    var bl1 = vers(BL, BR, r), br0 = vers(BR, BL, r), br1 = vers(BR, TR, r), tr0 = vers(TR, BR, r),
        tr1 = vers(TR, TL, r), tl0 = vers(TL, TR, r), tl1 = vers(TL, BL, r), bl0 = vers(BL, TL, r);
    return 'M' + f(bl1) +
      ' C' + f([bl1[0] + (br0[0] - bl1[0]) / 3, BAS + s1 * 1.33]) + ' ' + f([br0[0] - (br0[0] - bl1[0]) / 3, BAS + s1 * 1.33]) + ' ' + f(br0) +
      ' Q' + f(BR) + ' ' + f(br1) +
      ' C' + f([br1[0] + s3, br1[1] + (tr0[1] - br1[1]) / 3]) + ' ' + f([tr0[0] + s3, tr0[1] - (tr0[1] - br1[1]) / 3]) + ' ' + f(tr0) +
      ' Q' + f(TR) + ' ' + f(tr1) +
      ' C' + f([tr1[0] - (tr1[0] - tl0[0]) / 3, yt - s2 * 1.33]) + ' ' + f([tl0[0] + (tr1[0] - tl0[0]) / 3, yt - s2 * 1.33]) + ' ' + f(tl0) +
      ' Q' + f(TL) + ' ' + f(tl1) +
      ' C' + f([tl1[0] - s3, tl1[1] + (bl0[1] - tl1[1]) / 3]) + ' ' + f([bl0[0] - s3, bl0[1] - (bl0[1] - tl1[1]) / 3]) + ' ' + f(bl0) +
      ' Q' + f(BL) + ' ' + f(bl1) + ' Z';
  }
  function raies(l, p, liste) {
    var wb = l * UX, wt = wb * RETRAIT, h = p * UY, yt = BAS - h, s1 = wb * .055, s2 = wt * .11, s3 = h * .045;
    return liste.map(function (k) {
      var xb = CX + k * wb, xh = CX + k * wt,
          yb = BAS + s1 * (1 - Math.pow(k * 2, 2)) - 2.4, yh = yt - s2 * (1 - Math.pow(k * 2, 2)) + 2.4;
      return '<path d="M' + xb.toFixed(2) + ' ' + yb.toFixed(2) + ' Q' + ((xb + xh) / 2 + k * s3 * 2).toFixed(2) + ' ' + ((yb + yh) / 2).toFixed(2) + ' ' + xh.toFixed(2) + ' ' + yh.toFixed(2) + '"/>';
    }).join('');
  }
  function SchemaClosure(svg, options) {
    this.zone = svg.querySelector('.hm-schema-closure__zone');
    this.raies = svg.querySelector('.hm-schema-closure__raies');
    var d = lireFormat((options && options.format) || '4x4');
    this.l = d.l; this.p = d.p; this.stop = function () {};
    this.dessiner(d.l, d.p, raiesPour(d.l));
  }
  SchemaClosure.prototype.dessiner = function (l, p, liste) {
    this.zone.setAttribute('d', forme(l, p));
    this.raies.innerHTML = liste ? raies(l, p, liste) : '';
  };
  SchemaClosure.prototype.afficher = function (format) {
    var self = this, cible = lireFormat(format), dl = this.l, dp = this.p;
    this.stop();
    this.stop = animer(320, function (e) {
      self.l = dl + (cible.l - dl) * e; self.p = dp + (cible.p - dp) * e;
      self.dessiner(self.l, self.p, e < 1 ? null : raiesPour(cible.l));
    });
  };
  SchemaClosure.dimensions = lireFormat;

  window.HMIllustrations = { Silhouette: Silhouette, SchemaClosure: SchemaClosure, yPourLongueur: yPourLongueur };
})();
